export { WhatsAppWidget } from '@/components/common/WhatsAppWidget/WhatsAppWidget';
